// extracted by mini-css-extract-plugin
export var recipes = "dvlKd";
export var workouts = "_2bc1W";